import React, { useState } from 'react'
import SimpleReactValidator from 'simple-react-validator'

const useValidator = (customMessage = {}, customValidator = {}) => {




  SimpleReactValidator.addLocale('chi', {
    accepted:"这:attribute 必须接受 ",
    after :"这:attribute 必须在 :date 之后。",
    required: '这:attribute 字段是必需的',
    numeric: '这:attribute 必须是一个数字。',
    alpha:" 这:attribute 只能包含字母。",
    max: '这:attribute 不得大于  :max 人物',
    min: ' 必须至少:min:type.',
    size : '这:attribute 尺寸必须是 :size 人物',
    url :'这:attribute 必须是网址',
    email: "这:attribute 电子邮件必须是有效的电子邮件地址。",
    phone: "这:attribute 电话号码必须是有效的电话号码34。 ",
    alpha_space: "这:attribute 只能包含字母和空格。",
    alpha_num_space: "这:attribute  只能包含字母、数字和空格",
    alpha_num_dash_space: "这:attribute: 只能包含字母、数字、破折号和空格 ",
    date :"这:attribute: 必须是日期。",
    date_equals :"这:attribute: 必须在 :date",
    integer: "这:attribute: 必须是整数。",
    not_in :"这:attribute: 不能是 :values。",
    between: "这:attribute: 必须介于 :min 和 :max:type 之间。",
  
  });



  const [show, setShow] = useState(false)

  const isChaineesLanguage = localStorage.getItem('i18nextLng') === 'chi'

  const validator = new SimpleReactValidator({

    locale: isChaineesLanguage ? 'chi' : null,

    element: (message, className) => {

      console.log("msg11", message);
      return <div className="text-danger">{message}</div>
    },
    messages: customMessage,
    validators: customValidator,

  })

  if (show) {
    validator.showMessages()
  }

  return [validator, setShow]
}

export default useValidator;